import { isAxiosError } from 'axios';
import HttpService from '../HttpService';
import {
  IGetAllLabDeployments,
} from './types';

const startLab = async (payload: { eventId: string, challengeId?: string }, sessionToken?: string) => {
  try {
    const { data } = await HttpService.post<any>(
      'lab-deployment/start-lab-deployment',
      payload,
      sessionToken,
      undefined,
      { 'content-type': 'application/json' },
    );
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw error.response?.data;
    }
    throw error;
  }
};

const userDeleteLab = async (payload: { workspace: string }, sessionToken?: string) => {
  try {
    const { data } = await HttpService.post<any>(
      'lab-deployment/user/delete-lab-deployment',
      payload,
      sessionToken,
      undefined,
      { 'content-type': 'application/json' },
    );
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw error.response?.data;
    }
    throw error;
  }
};

const adminDeleteLab = async (payload: { workspace: string }, sessionToken?: string) => {
  try {
    const { data } = await HttpService.post<any>(
      'lab-deployment/admin/delete-lab-deployment',
      payload,
      sessionToken,
      undefined,
      { 'content-type': 'application/json' },
    );
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw error.response?.data;
    }
    throw error;
  }
};

const getAllLabDeployments = async (
  queryParams: {page: number, limit: number, eventId?: string, userId?: string, status?: string},
  sessionToken?: string,
) => {
  try {
    const { data } = await HttpService.get<IGetAllLabDeployments>(
      'lab-deployment/get-all-lab-deployments',
      sessionToken,
      queryParams,
    );
    return data;
  } catch (error) {
    throw error;
  }
};

const LabDeploymentService = {
  getAllLabDeployments,
  startLab,
  userDeleteLab,
  adminDeleteLab,
};

export default LabDeploymentService;
